import {createWebHistory, createRouter} from "vue-router";
import LandingPage from "@/LandingPage.vue";
import seoSlugs from "@/seo/seo-slugs.json";
import i18n from "@/i18n";

// Maps an SEO slug to its page component. Add an entry here when migrating a page.
const SeoPage = () => import("@/Pages/seo/SeoPage.vue");
const seoComponents = {
    "gym-management-software": () => import("@/Pages/seo/GymManagement.vue"),
    "fitness-studio-software": SeoPage,
    "pilates-studio-software": SeoPage,
    "yoga-studio-software": SeoPage,
    "class-booking-software": SeoPage,
    "gym-membership-billing-software": SeoPage,
    "personal-training-software": SeoPage,
    "online-class-booking-software": SeoPage,
    "fitness-marketing-software": SeoPage,
    "corporate-wellness-software": SeoPage,
};

const routes = [
    {
        path: "/",
        name: "landingPage",
        components: { default: LandingPage }
    },
    {
        path: "/el",
        name: "landingPageEl",
        components: { default: LandingPage }
    },
];

// Each migrated SEO page gets an English route (/slug) and a Greek route (/el/slug).
seoSlugs.forEach((slug) => {
    const component = seoComponents[slug];
    if (!component) return;
    routes.push({ path: `/${slug}`, name: slug, component });
    routes.push({ path: `/el/${slug}`, name: `el-${slug}`, component });
});

// Catch-all -> noindex 404 (dev server + any in-app unknown route).
routes.push({ path: "/:pathMatch(.*)*", name: "notFound", component: () => import("@/Pages/NotFound.vue") });

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    linkExactActiveClass: "active",
    routes: routes,
    scrollBehavior(to) {
        if (to.hash) return {el: to.hash, behavior: "smooth"};
        return {top: 0, behavior: "smooth"};
    },
});

// Synchronize translations before a reused route component renders. This also
// covers hosting-normalized URLs such as /el/ and /el/#pricing.
router.beforeEach((to) => {
    const locale = to.path === "/el" || to.path.startsWith("/el/") ? "el" : "en";
    if (i18n.global.locale !== locale) i18n.global.locale = locale;
    document.documentElement.setAttribute("lang", locale);
});

export default router;
